var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{attrs:{"per-page":3,"pagination-active-color":"#2a2ab5","pagination-color":"#bcc0d1","per-page-custom":[
    [400, 1],
    [600, 2],
    [700, 2],
    [800, 2],
    [900, 3],
    [1200, 3],
    [1500, 3],
    [1900, 3] ]}},_vm._l((_vm.carouselCardOptions),function(card,i){return _c('slide',{key:i},[_c('CarouselSideCard',{attrs:{"card":card}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }